import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { FilterItemShape } from '../../shapes';

const useStyles = makeStyles(({ palette, spacing }) => ({
  groupRoot: {
    marginTop: spacing(1),
    marginBottom: spacing(1),
  },
  labelRoot: {
    marginLeft: spacing(2),
    '& > .MuiButtonBase-root': {
      marginRight: spacing(1.5),
    },
  },
  radio: {
    color: palette.customStyling.backgroundColor,
  },
}));

const MobileFilterItemsRadioList = ({ name, value, options, onChange }) => {
  const classes = useStyles();
  const handleSelectItem = useCallback(event => onChange(event.target.value), [onChange]);
  return (
    <RadioGroup
      classes={{
        root: classes.groupRoot,
      }}
      aria-label={`aria-label-${name}`}
      name={name}
      value={value}
      onChange={handleSelectItem}
    >
      {options.map(option => (
        <FormControlLabel
          key={option.id}
          data-testid={`${name}-filterItemsRadio-${option.id}`}
          value={option.id}
          control={<Radio color="default" classes={{ root: classes.radio }} />}
          classes={{
            root: classes.labelRoot,
          }}
          label={option.label}
        />
      ))}
    </RadioGroup>
  );
};

MobileFilterItemsRadioList.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  options: PropTypes.arrayOf(FilterItemShape).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default memo(MobileFilterItemsRadioList);
